import React from 'react';
import './monitorItem.css';
import { useDispatch } from 'react-redux';
import { useHistory } from "react-router-dom";
import { closeWorkoutSagaAction } from "../../redux/sagaActions";
import { site } from "../../config";
import { keyNumberAction } from "../../redux/rootReducer";

const MonitorItem = ({ data }) => {
    const history = useHistory();
    const dispatch = useDispatch();

    return (
        <div className={ `monitor__item ${ !data.user.id ? 'monitor__item--no-hover' : '' }` } onClick={ () => {
            // Если нет id пользователя (разовое занятие), выходим из функции
            if (!data?.user?.id) return false;

            // Переходим на страницу с посетителями
            history.push('/fitness/users/' + data?.user?.id);
        } }>
            <i className="monitor__close" onClick={ event => {
                event.preventDefault();
                event.stopPropagation();
                dispatch(closeWorkoutSagaAction({
                    workout_id: data?.workout_id
                }));
            } } />
            <i className={ `monitor__key ${ data.key_number ? 'monitor__key--active' : '' }` }
                onClick={ event => {
                    event.preventDefault();
                    event.stopPropagation();
                    dispatch(keyNumberAction({
                        open: true,
                        number: data.key_number,
                        workout_id: data.workout_id,
                        type: 'save'
                    }));
                } }
            >
                {
                    data.key_number
                        ? <div className="monitor__key-number">{ data.key_number }</div>
                        : false
                }
            </i>
            <div className="monitor__content">
                {
                    data?.user?.avatar
                        ?
                        <img
                            src={ site + data?.user?.avatar }
                            className="monitor__avatar"
                            alt={ data?.user?.name }/>
                        : <div className="monitor__avatar monitor__avatar--no-image" />
                }
                <div className="monitor__info">
                    <div className={ `monitor__name ${ !data.user.id ? 'monitor__name--inactive' : '' }` }>{ data?.user?.name }</div>
                    <div className="monitor__phone">{ data?.user?.phone_formatted }</div>
                    {
                        data?.type?.id ? <div className="monitor__type">{ data?.type?.name }</div> : false
                    }
                </div>
            </div>
            <div className="monitor__start">{ `Начало в: ${ data.start }` }</div>
            { data.one_time ? <div className="monitor__one-time">Разовое посещение</div> : false }
            { data?.note ? <div className="monitor__note">{ data.note }</div> : false }
        </div>
    );
};

export default MonitorItem;